{
  "pt": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Modificar fase",
        "reset_columns": "Redefinir colunas"
      },
      "labels": {
        "columns": "Colunas",
        "milestone": "Selecionar uma nova fase",
        "no_results": "Não foram encontradas unidades"
      }
    }
  }
}
